export const getCoordinates = (location: { lat: string | number, lng: string | number }): { lat: number, lng: number } => {
  return { lat: Number(location.lat), lng: Number(location.lng) }
}